import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'// vuex可持久化存储
import getters from './getters'
import user from './modules/user'//用户相关
Vue.use(Vuex)
// 注册vuex
const store = new Vuex.Store({
  modules: {
    user,
  },
  getters,
  plugins: [createPersistedState({
    storage: {
      getItem: key => sessionStorage.getItem(key),
      setItem: (key, value) => sessionStorage.setItem(key, value),
      removeItem: key => sessionStorage.removeItem(key)
    }
  })]
})
export default store
